<template>
    <b-modal v-model="show" :title="'Саналар бўйича валюта қурсларини олиш'" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("report.date.startDate")}} <span class="red">*</span></label>
                        <datepicker
                                class="form-control"
                                format="dd/MM/yyyy"
                                v-model="currencyData.startDate"
                                :disabledDates="disabledDates"
                                :clear-button="true"
                                :class="{invalid : $v.currencyData.startDate.$error}"
                        ></datepicker>
                        <div class="red" v-if="$v.currencyData.startDate.$error">Қиймати</div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("report.date.endDate")}} <span class="red">*</span></label>
                        <datepicker
                                class="form-control"
                                format="dd/MM/yyyy"
                                v-model="currencyData.endDate"
                                :disabledDates="disabledDates"
                                :clear-button="true"
                                :class="{invalid : $v.currencyData.endDate.$error}"
                        ></datepicker>
                        <div class="red" v-if="$v.currencyData.endDate.$error">Қиймати</div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
                <i v-if="processing" class="fa fa-spinner fa-spin"></i>
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import { required } from 'vuelidate/lib/validators'
    import Datepicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';

    export default {
        name: "CurrencyRateByDate",
        components: {
            'b-modal': bModal,
            Datepicker: Datepicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                currencyData: {
                    startDate: '',
                    endDate: ''
                },
                disabledDates: {
                    from: new Date(Date.now() - 8640000)
                }
            }
        },
        validations: {
            currencyData: {
                startDate: {
                    required
                },
                endDate: {
                    required
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid || this.processing) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.currencyData.startDate = formatDate(this.currencyData.startDate);
                this.currencyData.endDate = formatDate(this.currencyData.endDate);
                this.$http.post('currency/save', this.currencyData).then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('currencyChanged', response);
                        }
                    this.currencyData.startDate = parseDate(this.currencyData.startDate);
                    this.currencyData.endDate = parseDate(this.currencyData.endDate);
                    location.reload();
                    });
            }
        },
        created() {
            this.$eventBus.$on('getCurrencyRateModal', () => {
                this.currencyData = {};
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>